import type { CustomFlowbiteTheme } from 'flowbite-react';

export const footerTheme: CustomFlowbiteTheme['footer'] = {
  root: {
    base: 'w-full rounded-none bg-titan-folly-500 shadow md:flex md:items-center md:justify-between',
    container: 'w-full p-0',
    bgDark: 'bg-titan-folly-600',
  },
  groupLink: {
    base: 'flex flex-wrap text-sm text-white',
    link: {
      base: 'me-4 last:mr-0 md:mr-6',
      href: 'hover:underline',
    },
    col: 'flex-col space-y-4',
  },
  icon: {
    base: 'hover:text-titan-yellow text-white',
    size: 'h-5 w-5',
  },
  title: {
    base: 'mb-6 text-sm font-semibold uppercase text-white',
  },
  divider: {
    base: 'border-titan-folly-400 my-6 w-full sm:mx-auto lg:my-8',
  },
  copyright: {
    base: 'text-sm text-white sm:text-center',
    href: 'ml-1 hover:underline',
    span: 'ml-1',
  },
  brand: {
    base: 'mb-4 flex items-center sm:mb-0',
    img: 'mr-3 h-8',
    span: 'self-center whitespace-nowrap text-2xl font-semibold text-white',
  },
};
